import PayViaLinkPage from '@/pages/pay-via-link';

export const PaymentContextPage = PayViaLinkPage;

export default PaymentContextPage;
